/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn, Tooltip, TooltipArrow, TooltipContent, TooltipTrigger } from '@landler/component-library';
import { useMemo } from 'react';

import { GenericTable } from '@/components/widgets/o/GenericTable/GenericTable';
import { SortButton } from '@/components/widgets/o/GenericTable/SortButton';
import { MetadataColumn } from '@/utils/table/mergeColumns';

export const ScoresHeatmap = ({
  group,
  title,
  data,
  className,
  factCell: FactCell,
}: {
  group?: string;
  title?: string;
  data: any[];
  className?: string;
  factCell?: ({ value }: { value?: number }) => JSX.Element | null;
}) => {
  const defaultColumns = useMemo<MetadataColumn<any>[]>(
    () => [
      {
        accessorKey: 'group',
        header: ({ column }) => <SortButton column={column as any}>{group ?? ''}</SortButton>,
        meta: {
          styles: {
            cell: 'max-w-[200px] truncate',
            header: 'max-w-[200px] truncate',
          },
        },
        cell: ({ getValue }) => {
          const value = getValue() as string;
          return (
            <Tooltip>
              <TooltipTrigger asChild>
                <span>{value}</span>
              </TooltipTrigger>
              <TooltipContent sideOffset={5} side='top'>
                {value}
                <TooltipArrow />
              </TooltipContent>
            </Tooltip>
          );
        },
      },
      ...Object.keys(data.length > 0 ? data[0] : {})
        .filter((key) => key !== 'group')
        .map((key) => ({
          accessorKey: key as string,
          header: ({ column }: { column: any }) => <SortButton column={column}>{key as string}</SortButton>,
          cell: ({ getValue }: { getValue: any }) => {
            return FactCell ? <FactCell value={getValue()} /> : <span>{getValue()}</span>;
          },
        })),
    ],
    [data, FactCell, group],
  );

  return (
    <GenericTable
      data-testid='heatmap-table'
      title={title}
      data={data}
      defaultColumns={defaultColumns}
      className={cn('border-none shadow-none', className)}
      styles={{
        row: 'border-none',
        cell: 'border-none p-1',
        header: 'border-none [&_tr]:border-none',
        head: 'text-center max-w-[200px] truncate',
        title: 'typography-overline text-lg text-text-secondary font-normal',
      }}
    />
  );
};
